import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { BlogsProps } from './types'
import { BlogHeader } from './BlogHeader'
import { BlogGrid } from './BlogGrid'
import { ScubscriptionPanel } from './Components'

export const BlogsLandingPage: FC<BlogsProps> = ({
  seo,
  header,
  footer,
  blogLists,
  meta,
  content: {
    breadcrumb,
    no_results,
    sidebar,
    name,
    description,
    banner_image,
    newsletter,
    search_placeholder,
    search_result,
    view_all,
    tag_lists
  }
}) => (
  <Page seo={seo} header={header} footer={footer}>
    <Featured
      breadcrumb={breadcrumb}
      name={name}
      description={description}
      banner_image={banner_image}
      tags={[]}
      featured_media={seo?.featured_media || 0}
      seo={seo}
    />
    <BlogHeader
      blogLists={blogLists}
      search_placeholder={search_placeholder}
      search_result={search_result}
      tag_lists={tag_lists}
      sidebar={sidebar}
      no_results={no_results}
      view_all={view_all}
    />
    <BlogGrid blogLists={blogLists} meta={meta} />
    <ScubscriptionPanel newsletter={newsletter} />
  </Page>
)
